import { render } from "./ComentariosConvocatoriaModal.vue?vue&type=template&id=bc512aec"
import script from "./ComentariosConvocatoriaModal.vue?vue&type=script&lang=js"
export * from "./ComentariosConvocatoriaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__